import Auth from '@/Auth/Auth';
import Styles from './index.module.sass';

interface PaginationProps
{
    recordsTotal: number;
    currentPage: number;
    itemsPerPage: number;
    onChangePage: (newPage: number) => void;
    onChangeItemsPerPage?: (newItemsPerPage: number) => void;
}

export const Pagination: React.FC<PaginationProps> = ({recordsTotal, currentPage, itemsPerPage, onChangePage, onChangeItemsPerPage}) =>
{
    return(
        <div className={Styles.PaginationContainer}>
            <div className={Styles.ItemsPerPage}>
                <span style={{cursor: 'default'}}>Items por página</span>
                {onChangeItemsPerPage ?
                (
                    <select onChange={(event: React.ChangeEvent<HTMLSelectElement>) =>
                        {
                            Auth.setQtyPage(parseInt(event.target.value));
                            onChangePage(0);
                            onChangeItemsPerPage(parseInt(event.target.value));
                        }}
                        defaultValue={itemsPerPage || Number(Auth.getQtyPage()) || 10}
                    >
                        <option value={10}>10</option>
                        <option value={20}>20</option>
                        <option value={30}>30</option>
                        <option value={40}>40</option>
                        <option value={50}>50</option>
                    </select>
                ) :
                (
                    <span style={{marginLeft: 6, fontWeight: 600, cursor: 'default'}}>{itemsPerPage}</span>
                )}
            </div>
            <div className={Styles.PageCount}>
                <span style={{cursor: 'default'}}>{`${currentPage + 1}-${itemsPerPage} de ${Math.ceil(recordsTotal / itemsPerPage)}`}</span>
            </div>
            <div className={Styles.PageButtons}>
                <button onClick={() =>
                    {
                        if(currentPage > 0)
                        {
                            onChangePage(currentPage - 1);
                        }
                    }}
                    className={currentPage === 0 ? Styles.disabled : ""}
                >
                    <i className={"ironia-icon keyboard-arrow-left"} />
                </button>
                <button onClick={() =>
                    {
                        if(currentPage < Math.ceil(recordsTotal / itemsPerPage) - 1)
                        {
                            onChangePage(currentPage + 1);
                        }
                    }}
                    className={Math.ceil(recordsTotal / itemsPerPage) === currentPage + 1 ? Styles.disabled : ""}
                >
                    <i className={"ironia-icon keyboard-arrow-right"} />
                </button>
            </div>
        </div>
    );
};